module.exports = __webpack_public_path__ + "img/231.meeting_room.16b25b67.svg";